export { default } from './HeadingBlock'
